import { useAuthStore } from '@/stores/auth'
import BaseMiddleware from './BaseMiddleware'

export default class Guest extends BaseMiddleware {
    handle(request, next) {
        useAuthStore().load(false).then(() => {
            request.router.next('/')
        }).catch((e) => {
            console.warn(e)
            next(request)
        })
    }
}
